import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const MasterAuthContext = createContext(null);

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export function MasterAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const token = localStorage.getItem('masterToken');
      if (!token) {
        setUser(false);
        setLoading(false);
        return;
      }
      
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.role === 'master') {
        setUser(response.data);
      } else {
        localStorage.removeItem('masterToken');
        setUser(false);
      }
    } catch (error) {
      localStorage.removeItem('masterToken');
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/master/login`, { email, password });
    localStorage.setItem('masterToken', response.data.token);
    setUser(response.data);
    return response.data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {});
    } catch (e) {
      // Ignore logout errors
    }
    localStorage.removeItem('masterToken');
    setUser(false);
  };

  return (
    <MasterAuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>
      {children}
    </MasterAuthContext.Provider>
  );
}

export function useMasterAuth() {
  const context = useContext(MasterAuthContext);
  if (!context) {
    throw new Error('useMasterAuth must be used within MasterAuthProvider');
  }
  return context;
}
